module.exports = __webpack_public_path__ + "img/logo.1498cc79.svg";